export const EMessageType = {
  Success: 'success',
  Info: 'info',
  Warning: 'warning',
  Error: 'error',
  network: 'network',
  serverError: 'Something went wrong', // ✅ add this

};

export const axiosMethods = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
};
export const toastMessageText = {
  serverError: 'An internal server error occurred. Please try again later.',
  networkConnection:
    "We can't reach our network right now.\nPlease check your connection",
};